<mat-tab-group mat-stretch-tabs class="tab_group">
    <!-- <mat-tab label="VIEW" *ngIf="persistenceService.get('viewDisable') == 'true'"> -->
    <mat-tab class="tab_content" *ngIf="persistenceService.get('viewDisable') == 'true'">
        <ng-template mat-tab-label>
            <div style="display: flex; flex-direction: column; align-items: center; width: 100%;">
                <div class="tab-label-container">
                    <span class="tab-title">MONITORING DASHBOARD</span>
                    <span class="filter-icon">
                        <mat-icon [matMenuTriggerFor]="menu">filter_list</mat-icon>
                    </span>
                </div>
                <div class="subheader">
                    <span class="subheader-text">Updated every 30 seconds</span>
                </div>
            </div>
        </ng-template>
        <!-- <mat-icon style="float: right;" class="sortbar_icon" >filter_list</mat-icon> -->
        <mat-menu #menu="matMenu" class="custom_menu">
            <div class="sortbar_tabs_icon" *ngFor="let value of btnValues">
                <button class="sortbar_tab_btn global-button" type="button" (click)="applyFlter(value)"
                    [ngClass]="{ 'sortbar_tab_btn_active': activeSort === value }">{{value}}</button>
                <!-- <button class="sortbar_tab_btn global-button" type="button" (click)="applyFlter('Current Week')">Current
                    Week</button>
                <button class="sortbar_tab_btn global-button" type="button" (click)="applyFlter('Current Month')">Current
                    Month</button>
                <button class="sortbar_tab_btn global-button" type="button" (click)="applyFlter('Current Quarter')">Current
                    Quarter</button>
                <button class="sortbar_tab_btn global-button" type="button" (click)="applyFlter('Current Year')">Current
                    Year</button> -->
            </div>
        </mat-menu>
        <div class="rightside-table-container" id="rightside-table">
            <div id="cr-upper-div">
                <div class="row" id="cr-upperdiv-firstrow">
                    <div class="dashboardname_holder">
                        <h4 class="my-font global-h4">Web Orders</h4>
                    </div>

                    <div class="dashboarddetail_holder" style="padding: 3px;" data-simplebar>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                            *ngFor="let dashboardDto of dashboardDtoForWebOrderList">
                            <div class="org_dtls_btn">
                                <div class="dashboard_dtls_container md-ink-ripple"
                                    style="max-height: 81px !important;">
                                    <div class="org_head">
                                        <p class="org_title my-font textOverFlow global-p">
                                            {{dashboardDto?.subHeading}}</p>
                                    </div>
                                </div>

                                <div class="dashboardstatus_holder">
                                    <div class="red_color head_content_div">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{dashboardDto?.firstHeading}}</div>
                                            <div class="my-font">
                                                {{dashboardDto?.redColor}}</div>
                                        </div>
                                    </div>
                                    <div class="yellow_color head_content_div">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{dashboardDto?.secondHeading}}</div>
                                            <div class="my-font">
                                                {{dashboardDto?.yellowColor}}</div>
                                        </div>
                                    </div>
                                    <div class="green_color head_content_div">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{dashboardDto?.thirdHeading}}</div>
                                            <div class="my-font">
                                                {{dashboardDto?.greenColor}}</div>
                                        </div>
                                    </div>
                                    <div
                                        [ngClass]=" dashboardDto?.subHeading == 'Web Commerce' ? 'lightBlue head_content_div' : 'grey_color head_content_div'">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{dashboardDto?.fourthHeading}}</div>
                                            <div class="my-font">
                                                {{dashboardDto?.greyColor}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div id="cr-upper-div">
                <div class="row" id="cr-upperdiv-firstrow">
                    <div class="dashboardname_holder">
                        <h4 class="my-font global-h4">Track</h4>
                    </div>

                    <div class="dashboarddetail_holder" style="padding: 3px;" data-simplebar>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                            *ngFor="let trackDto of dashboardDtoForTrackList">
                            <div class="org_dtls_btn">
                                <div class="dashboard_dtls_container md-ink-ripple"
                                    style="max-height: 81px !important;">
                                    <div class="org_head">
                                        <p class="org_title my-font textOverFlow global-p">
                                            {{trackDto?.subHeading}}</p>
                                    </div>
                                </div>

                                <div class="dashboardstatus_holder">
                                    <div
                                        [ngClass]=" trackDto?.subHeading == 'Coupon Redemption' || trackDto?.subHeading === 'Spin N Win Redemption' ? 'red_color head_content_div2' : trackDto?.subHeading == 'Store Reporting' ? 'green_color head_content_div3' :'red_color head_content_div'">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{trackDto?.firstHeading}}</div>
                                            <div class="my-font">
                                                {{trackDto?.redColor}}</div>
                                        </div>
                                    </div>
                                    <div [ngClass]=" trackDto?.subHeading == 'Coupon Redemption' || trackDto?.subHeading === 'Spin N Win Redemption' ? 'yellow_color head_content_div2' : 'yellow_color head_content_div'"
                                        *ngIf="trackDto?.subHeading != 'Store Reporting'">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{trackDto?.secondHeading}}</div>
                                            <div class="my-font">
                                                {{trackDto?.yellowColor}}</div>
                                        </div>
                                    </div>
                                    <div [ngClass]=" trackDto?.subHeading == 'Coupon Redemption' || trackDto?.subHeading === 'Spin N Win Redemption' ? 'green_color head_content_div2' : 'green_color head_content_div'"
                                        *ngIf="trackDto?.subHeading != 'Store Reporting'">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{trackDto?.thirdHeading}}</div>
                                            <div class="my-font">
                                                {{trackDto?.greenColor}}</div>
                                        </div>
                                    </div>
                                    <div class="grey_color head_content_div"
                                        *ngIf="trackDto?.subHeading !== 'Coupon Redemption' && trackDto?.subHeading !== 'Spin N Win Redemption' && trackDto?.subHeading !== 'Store Reporting'">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{trackDto?.fourthHeading}}</div>
                                            <div class="my-font">
                                                {{trackDto?.greyColor}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div id="cr-upper-div">
                <div class="row" id="cr-upperdiv-firstrow">
                    <div class="dashboardname_holder">
                        <h4 class="my-font global-h4">Response Management</h4>
                    </div>

                    <div class="dashboarddetail_holder" style="padding: 3px;" data-simplebar>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                            *ngFor="let responseDto of dashboardDtoForResponseList">
                            <div class="org_dtls_btn">
                                <div class="dashboard_dtls_container md-ink-ripple"
                                    style="max-height: 81px !important;">
                                    <div class="org_head">
                                        <p class="org_title my-font textOverFlow global-p">
                                            {{responseDto?.subHeading}}</p>
                                    </div>
                                </div>

                                <div class="dashboardstatus_holder">
                                    <div class="red_color head_content_div">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{responseDto?.firstHeading}}</div>
                                            <div class="my-font">
                                                {{responseDto?.redColor}}</div>
                                        </div>
                                    </div>
                                    <div class="yellow_color head_content_div">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{responseDto?.secondHeading}}</div>
                                            <div class="my-font">
                                                {{responseDto?.yellowColor}}</div>
                                        </div>
                                    </div>
                                    <div class="green_color head_content_div">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{responseDto?.thirdHeading}}</div>
                                            <div class="my-font">
                                                {{responseDto?.greenColor}}</div>
                                        </div>
                                    </div>
                                    <div class="grey_color head_content_div">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{responseDto?.fourthHeading}}</div>
                                            <div class="my-font">
                                                {{responseDto?.greyColor}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div id="cr-upper-div">
                <div class="row" id="cr-upperdiv-firstrow">
                    <div class="dashboardname_holder">
                        <h4 class="my-font global-h4">Order Management</h4>
                    </div>

                    <div *ngIf="monitoringDashboardDto?.application" class="dashboarddetail_holder"
                        style="padding: 3px;" data-simplebar>
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="org_dtls_btn">
                                <div class="dashboard_dtls_container md-ink-ripple"
                                    style="max-height: 81px !important;">
                                    <div class="org_head">
                                        <div class="org_title my-font textOverFlow">
                                            <mat-select panelClass="custom-select-panel" class="custom-select"
                                                [(ngModel)]="selectedInventory"
                                                (selectionChange)="onSelectOrderType($any($event).value)">
                                                <mat-option [value]="'all'">All Orders</mat-option>
                                                <mat-option *ngFor="let c of ordersList"
                                                    [value]="c.inventoryCode">{{c.inventoryName}}</mat-option>
                                            </mat-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="dashboardstatus_holder">
                                    <div class="red_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{orderDashboardDto?.firstHeading}}</div>
                                            <div class="my-font">
                                                {{orderDashboardDto?.redColor}}</div>
                                        </div>
                                    </div>
                                    <div class="yellow_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{orderDashboardDto?.secondHeading}}</div>
                                            <div class="my-font">
                                                {{orderDashboardDto?.lightYellow}}</div>
                                        </div>
                                    </div>
                                    <div class="dark_yellow_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{orderDashboardDto?.thirdHeading}}</div>
                                            <div class="my-font">
                                                {{orderDashboardDto?.darkYellow}}</div>
                                        </div>
                                    </div>
                                    <div class="green_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{orderDashboardDto?.fourthHeading}}</div>
                                            <div class="my-font">
                                                {{orderDashboardDto?.greenColor}}</div>
                                        </div>
                                    </div>
                                    <div class="grey_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{orderDashboardDto?.fifthHeading}}</div>
                                            <div class="my-font span_flex">
                                                <span>{{orderDashboardDto?.greyColor}}</span>
                                                <span class="span_flex_size">
                                                    (<span
                                                        class="span_green">{{orderDashboardDto?.confirmed}}</span>/<span
                                                        class="span_red">{{orderDashboardDto?.declined}}</span>)
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="org_dtls_btn">
                                <div class="dashboard_dtls_container md-ink-ripple"
                                    style="max-height: 81px !important;">
                                    <div class="org_head">
                                        <p class="org_title my-font textOverFlow global-p">
                                            Make To Order</p>
                                    </div>
                                </div>

                                <div class="dashboardstatus_holder">
                                    <div class="red_color head_content_div">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                UnResolved</div>
                                            <div class="my-font">
                                                {{monitoringDashboardDto?.application?.makeToOrders?.unResolved}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="yellow_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                In Process</div>
                                            <div class="my-font">
                                                {{monitoringDashboardDto?.application?.makeToOrders?.inProcess}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="dark_yellow_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                Dispatched</div>
                                            <div class="my-font">
                                                {{monitoringDashboardDto?.application?.makeToOrders?.dispatched}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="green_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                Received</div>
                                            <div class="my-font">
                                                {{monitoringDashboardDto?.application?.makeToOrders?.received}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="grey_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                Total</div>
                                            <div class="my-font span_flex">
                                                {{monitoringDashboardDto?.application?.makeToOrders?.totalOrders}}
                                                <span class="span_flex_size">
                                                    (<span
                                                        class="span_green">{{monitoringDashboardDto?.application?.makeToOrders?.confirmed}}</span>/<span
                                                        class="span_red">{{monitoringDashboardDto?.application?.makeToOrders?.declined}}</span>)
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="org_dtls_btn">
                                <div class="dashboard_dtls_container md-ink-ripple"
                                    style="max-height: 81px !important;">
                                    <div class="org_head">
                                        <div class="org_title my-font textOverFlow">
                                            <mat-select panelClass="custom-select-panel" class="custom-select"
                                                [(ngModel)]="selectedReturnInventory"
                                                (selectionChange)="onSelectReturnOrderType($any($event).value)">
                                                <mat-option [value]="'all'">All Returns</mat-option>
                                                <mat-option *ngFor="let c of returnOrdersList"
                                                    [value]="c.inventory">Return
                                                    {{c.inventoryName}}</mat-option>
                                            </mat-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="dashboardstatus_holder">
                                    <div class="red_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{returnOrderDashboardDto?.firstHeading}}</div>
                                            <div class="my-font">
                                                {{returnOrderDashboardDto?.redColor}}</div>
                                        </div>
                                    </div>
                                    <div class="yellow_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{returnOrderDashboardDto?.secondHeading}}</div>
                                            <div class="my-font">
                                                {{returnOrderDashboardDto?.lightYellow}}</div>
                                        </div>
                                    </div>
                                    <div class="dark_yellow_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{returnOrderDashboardDto?.thirdHeading}}</div>
                                            <div class="my-font">
                                                {{returnOrderDashboardDto?.darkYellow}}</div>
                                        </div>
                                    </div>
                                    <div class="green_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{returnOrderDashboardDto?.fourthHeading}}</div>
                                            <div class="my-font">
                                                {{returnOrderDashboardDto?.greenColor}}</div>
                                        </div>
                                    </div>
                                    <div class="grey_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                {{returnOrderDashboardDto?.fifthHeading}}</div>
                                            <div class="my-font">
                                                {{returnOrderDashboardDto?.greyColor}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="org_dtls_btn">
                                <div class="dashboard_dtls_container md-ink-ripple"
                                    style="max-height: 81px !important;">
                                    <div class="org_head">
                                        <p class="org_title my-font textOverFlow global-p">
                                            Return Make To Order</p>
                                    </div>
                                </div>

                                <div class="dashboardstatus_holder">
                                    <div class="red_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                UnResolved</div>
                                            <div class="my-font">
                                                0</div>
                                        </div>
                                    </div>
                                    <div class="yellow_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                In Process</div>
                                            <div class="my-font">
                                                {{monitoringDashboardDto?.application?.returnMtoOrders?.orders -
                                                monitoringDashboardDto?.application?.returnMtoOrders?.received}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="dark_yellow_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                Dispatched</div>
                                            <div class="my-font">
                                                0</div>
                                        </div>
                                    </div>
                                    <div class="green_color head_content_div">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                Received</div>
                                            <div class="my-font">
                                                {{monitoringDashboardDto?.application?.returnMtoOrders?.received}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="grey_color head_content_div4">
                                        <div class="content_div">
                                            <div class="my-font-header">
                                                Total</div>
                                            <div class="my-font">
                                                {{monitoringDashboardDto?.application?.returnMtoOrders?.orders}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>
    </mat-tab>
</mat-tab-group>